<script>
    export let value = {};
    export let title = "";
    export let inputClass = "";
    export let titleClass = "";
    export let isDisabled = false;
    export let isLong = false;
    export let onChangeFunc = () => {};
    export let wrapperClass = "";

    const defaultTitleClass = "text-[11px] font-[500]";
    const defaultClass = isLong
        ? "input-sm w-48 bg-gray-200"
        : "input-sm w-32 bg-gray-200";
</script>

<div class="flex flex-col {wrapperClass}">
    <p class={defaultTitleClass + " " + titleClass}>{title}</p>
    <select
        bind:value
        class={defaultClass + " " + inputClass}
        on:change|preventDefault={onChangeFunc}
        disabled={isDisabled}
    >
        <slot />
    </select>
</div>

<style>
    p {
        color: #6f726c;
    }

    select {
        outline: 0;
        border-width: 0 0 2px;
        border-color: #818e9b;
    }

    select:focus {
        border-color: #270053;
    }
</style>
